import NumberRounding from '../utils/numberRounding';

export default class PanelService {

    static getIDSPanels(panels) {   
        const filteredPanels = panels.filter(p => p.externalKey !== null && p.externalKey !== '');
        return filteredPanels; 
    }

    static getIDSPanelsThatMatchesTargetSoV(targetSoV, soVFaultTolerance, soVNoOfDecimals, panels, useNewSoVCalculation) {
        const targetSoVIncFaultTolerance = NumberRounding.round(targetSoV * 100 * soVFaultTolerance, soVNoOfDecimals);

        if (useNewSoVCalculation) {
            return panels.filter(p => p.reachedSov && p.externalKey !== null && p.externalKey !== '');
        }

        return panels.filter(p => NumberRounding.round(p.soV * 100, soVNoOfDecimals) >= targetSoVIncFaultTolerance && p.externalKey !== null && p.externalKey !== '');

    }

    static getFixedIDSPanelsThatMatchesTargetSoV(targetSoV, soVFaultTolerance, soVNoOfDecimals, panels, useNewSoVCalculation) {
        const targetSoVIncFaultTolerance = NumberRounding.round(targetSoV * 100 * soVFaultTolerance, soVNoOfDecimals);

        if (useNewSoVCalculation)
            return panels.filter(p => NumberRounding.round(p.soV / targetSoV, soVNoOfDecimals) >= soVFaultTolerance && p.externalKey !== null && p.externalKey !== '');

        return panels.filter(p => NumberRounding.round(p.soV * 100, soVNoOfDecimals) >= targetSoVIncFaultTolerance && p.externalKey !== null && p.externalKey !== '');
    }

    static getPanelsThatMatchesTargetSoV(targetSoV, soVFaultTolerance, soVNoOfDecimals, panels, useNewSoVCalculation) {
        const targetSoVIncFaultTolerance = NumberRounding.round(targetSoV * 100 * soVFaultTolerance, soVNoOfDecimals);

        if (useNewSoVCalculation)
            return panels.filter(p => NumberRounding.round(p.soV / targetSoV, soVNoOfDecimals) >= soVFaultTolerance);

        return panels.filter(p => NumberRounding.round(p.soV * 100, soVNoOfDecimals) >= targetSoVIncFaultTolerance);
    }

    // to not be used, only needed for retro compatibility
    static getPanelsForFxpBeforeCutoffDate(targetSoV, soVFaultTolerance, soVNoOfDecimals, panels, useNewSoVCalculation) {
        const targetSoVIncFaultTolerance = NumberRounding.round(targetSoV * soVFaultTolerance, soVNoOfDecimals);

        if (useNewSoVCalculation)
            return panels.filter(p => NumberRounding.round(p.soV / targetSoV, soVNoOfDecimals) >= soVFaultTolerance);

        return panels.filter(p => NumberRounding.round(p.soV * 100, soVNoOfDecimals) >= targetSoVIncFaultTolerance);
        
    }
}